<ce-banner [themeClass]="themeClass"></ce-banner>

<div class="topbar-main fx-row fx-layout-align-space-between-center">
    <!-- hamburger menu icon -->
    <button class="menu topbar-nav-trigger" mat-icon-button [matMenuTriggerFor]="navMenu">
        <mat-icon>menu</mat-icon>
    </button>

    <!-- Navigation buttons -->
    <mat-menu #navMenu="matMenu" [overlapTrigger]="false">
        <div *ngIf="chargeye2Link$ | async as chargeye2Link">
            <a
                *ngIf="chargeye2Link.skipDialog; else betaLinkDialogButton"
                target="_self"
                [href]="chargeye2Link.betaLink"
                class="topbar-CeBetaLink topbar-CeBetaLink--link"
                rel="noopener"
            >
                <mat-icon svgIcon="k-bolt-link"></mat-icon>
                ChargEye beta
            </a>
            <ng-template #betaLinkDialogButton>
                <button mat-button (click)="navigateToBeta()" class="topbar-CeBetaLink">
                    <mat-icon svgIcon="k-bolt-link"></mat-icon>
                    ChargEye beta
                </button>
            </ng-template>
        </div>

        <ng-container *ngFor="let btn of filteredButtons">
            <a mat-menu-item [routerLinkActive]="'active'" [routerLink]="[btn.routerLink]"
                ><mat-icon [svgIcon]="btn.svgIcon"></mat-icon>{{ btn.name | translate }}</a
            >
        </ng-container>
    </mat-menu>

    <div class="topbar-content fx-row fx-layout-align-space-between-center fx-flex-100">
        <!-- kempower logo -->
        <div
            class="logo-container logo-container-big fx-row fx-layout-align-start-center fx-layout-gap-8"
            [ngClass]="{ 'admin-section': sectionName }"
        >
            <!-- logo -->
            <img
                alt="kempower"
                [src]="
                    themeClass === 'theme-mykempower' || isDarkMode
                        ? 'assets/kempower-logo-inverse.svg'
                        : 'assets/kempower-logo.svg'
                "
                class="logo logo-big"
                (click)="navigateToHome()"
                (keydown.enter)="navigateToHome()"
            />
            <!-- app name -->
            <span class="app-name fx-hide-lt-xs" [ngClass]="{ 'mykempower-name': themeClass === 'theme-mykempower' }">
                {{ themeClass === 'theme-mykempower' ? 'MyKempower' : 'ChargEye' }}
            </span>
            <!-- section name -->
            <span class="section-name fx-hide-lt-xs" *ngIf="sectionName">{{ sectionName }}</span>
        </div>

        <!-- Kempower logo without text for smaller screen sizes -->
        <img
            alt="kempower"
            class="logo logo-small logo-container-small"
            src="assets/kempower-bullet-logo.svg"
            (click)="navigateToHome()"
            (keydown.enter)="navigateToHome()"
        />

        <div class="fx-row fx-layout-align-start-center fx-layout-gap-8 fx-hide-lt-xs">
            <!-- organization and license name -->
            <div class="topbar-description fx-column fx-layout-align-start-end fx-flex-100">
                <span class="ce-organization">{{ organizationName$ | async }}</span>
                <span class="ce-license">{{ licenseName$ | async | licenseName }}</span>
            </div>
        </div>
    </div>

    <!-- global search field -->
    <div
        class="search fx-layout-align-center-center"
        [class.active]="isSearchFieldActive$ | async"
        *ngIf="hasPermissionsToSearch$ | async"
    >
        <ce-search [themeClass]="themeClass" (searchFocused)="setSearchActive($event)"></ce-search>
    </div>
    <div class="timezone fx-layout-align-space-between-center">
        <!-- timezone selection -->
        <ce-time-display [themeClass]="themeClass"></ce-time-display>
    </div>
    <div class="release-note fx-layout-align-center-center">
        <ce-release-info [themeClass]="themeClass"></ce-release-info>
    </div>
    <div class="profile fx-layout-align-center-center">
        <ce-profile [themeClass]="themeClass"></ce-profile>
    </div>
</div>
